import { useContext, useEffect, useState } from 'react';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';
import getBonusPeriodsRef from './getBonusPeriodsRef';

/**
 * Legacy bonus periods for use at Navajo and NCI
 */
const useBonusPeriods = () => {
  const [bonusPeriods, setBonusPeriods] = useState<
    BonusPeriod[] | BonusTypes.BonusPeriod[]
  >([]);
  const [currentBonusPeriod, setCurrentBonusPeriod] = useState<
    BonusPeriod | BonusTypes.BonusPeriod | undefined
  >();
  const { accountRef } = useContext(AccountPickerContext);

  useEffect(() => {
    const listener = getBonusPeriodsRef(accountRef).onSnapshot(
      (snapshot: any) => {
        const data: BonusPeriod[] | BonusTypes.BonusPeriod[] = [];
        snapshot.docs.forEach((d: any) =>
          data.push({
            ...d.data(),
          }),
        );
        setBonusPeriods(
          data.map((bp) => {
            if (!bp.status) {
              const x: BonusPeriod | BonusTypes.BonusPeriod = {
                // @ts-ignore
                ...bp,
                status: 'in review' as 'in review',
              };
              return x;
            }
            return bp;
          }),
        );
        setCurrentBonusPeriod(data.find((bp) => bp.status === 'active'));
      },
    );
    return () => {
      listener();
    };
  }, [accountRef]);

  return {
    bonusPeriods,
    currentBonusPeriod,
  };
};

export default useBonusPeriods;
